import { Dispatch, SetStateAction } from "react";

import { useTranslation } from "react-i18next";

import { Divider } from "simplydo/react/ui/divider";
import { Form, FormField } from "simplydo/react/ui/form";
import { H5 } from "simplydo/react/ui/header";
import { Input } from "simplydo/react/ui/input";

import { IYourIdeaFilters } from "components/challenges/YourIdeas";

import Checkbox from "../Forms/Checkbox";
import Radio from "../Forms/Radio";

type YourIdeasFiltersProps = {
  setFilters: Dispatch<SetStateAction<IYourIdeaFilters>>;
  showDraft: boolean;
  showSubmitted: boolean;
  sort: string;
  filter: string;
};

const YourIdeasFilters = ({
  setFilters,
  showDraft,
  showSubmitted,
  sort,
  filter,
}: YourIdeasFiltersProps) => {
  const { t } = useTranslation();
  return (
    <Form style={{ padding: 0 }}>
      <FormField
        control={Input}
        placeholder={t("ideas.yours.sidebar.search")}

        value={filter}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilters((prevState) => ({ ...prevState, filter: e.target.value }))
        }
      />
      <Divider hidden />
      <Checkbox
        checked={showDraft}
        onChange={() =>
          setFilters((prevState) => ({ ...prevState, showDraft: !showDraft }))
        }
      >
        {t("ideas.yours.sidebar.draft")}
      </Checkbox>
      <Checkbox
        checked={showSubmitted}
        onChange={() =>
          setFilters((prevState) => ({
            ...prevState,
            showSubmitted: !showSubmitted,
          }))
        }
      >
        {t("ideas.yours.sidebar.submitted")}
      </Checkbox>
      <H5>Order by</H5>
      <Radio
        name="sort"
        checked={sort === "newest"}
        onChange={() =>
          setFilters((prevState) => ({ ...prevState, sort: "newest" }))
        }
      >
        {t("order.newest")}
      </Radio>
      <Radio
        name="sort"
        checked={sort === "oldest"}
        onChange={() =>
          setFilters((prevState) => ({ ...prevState, sort: "oldest" }))
        }
      >
        {t("order.oldest")}
      </Radio>
    </Form>
  );
};

export default YourIdeasFilters;
